import React from 'react';

export const labelCss = { display: 'block', fontSize: 12, color: '#6b7280', marginBottom: 4 };
export const inputCss = { width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, fontFamily: "'Open Sans', sans-serif", background: '#fff' };
export const errorCss = { background: '#fee2e2', color: '#991b1b', padding: '10px 12px', borderRadius: 8, marginTop: 12, fontSize: 13 };
export const primaryBtn = function(disabled) {
  return { padding: '9px 18px', background: '#1a7a4a', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, fontSize: 14, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.55 : 1 };
};
export const secondaryBtn = { padding: '9px 18px', background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, fontWeight: 600, fontSize: 14, cursor: 'pointer' };

// Shared modal frame for the payout dialogs. Clicking the backdrop closes it unless a request is running.
const PayoutDialogShell = ({ title, onClose, busy, children }) => (
  <div role="dialog" aria-modal="true" aria-label={title}
    onClick={function(e) { if (e.target === e.currentTarget && !busy) onClose(); }}
    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }}>
    <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: '100%', maxWidth: 460, maxHeight: '90vh', overflowY: 'auto', fontFamily: "'Open Sans', sans-serif" }}>
      <h2 style={{ margin: '0 0 12px', fontSize: '1.1rem', color: '#1a3d2b', fontFamily: "'Raleway', sans-serif" }}>{title}</h2>
      {children}
    </div>
  </div>
);

export default PayoutDialogShell;
